import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HotelService } from '../../hotel.service';
import { AlertService } from 'app/core-lib/services/alerts/alert.service';


@Component({
    selector: 'mh-info-contact-guest',
    templateUrl: './info-contact-guest.component.html',
    styleUrls: ['./info-contact-guest.component.scss'],
    standalone: false
})
export class InfoContactGuestComponent implements OnInit {
  @Input() customer_id: string;
  guestContactForm: FormGroup;

  constructor(private fb: FormBuilder, private hotelService: HotelService, private alertService: AlertService) {}
  // IMPLEMENTAR LOADER
  waiting = false;

  ngOnInit() {
    this.initForm();
    if (this.customer_id) {
      this.getGuestContactInfo(this.customer_id);
    }
  }

  private initForm() {
    this.guestContactForm = this.fb.group({
      phone: ['', [Validators.pattern('^[+]?[0-9]*$')]],
      internal_reception_number: ['', [Validators.pattern('^[0-9]*$')]],
      mobile_phone: ['', [Validators.pattern('^[+]?[0-9]*$')]],
      email: ['', [Validators.email]],
      instagram: ['']
    });
  }

  // Métodos helper para la template
  hasError(controlName: string): boolean {
    const control = this.guestContactForm.get(controlName);
    return control ? control.invalid && (control.dirty || control.touched) : false;
  }

  getErrorMessage(controlName: string): string {
    const control = this.guestContactForm.get(controlName);
    if (control?.errors) {
      if (control.errors['email']) return 'models.hotel_dto.guest_contact.formErrors.email';
      if (control.errors['pattern']) return 'models.hotel_dto.guest_contact.formErrors.format';
    }
    return '';
  }

  getGuestContactInfo(customer_id){
    this.hotelService.getGuestContactInfo(customer_id).subscribe(data => {
      this.guestContactForm.patchValue(data);
    });
  }

  saveContact(){    
    if(  !this.guestContactForm.valid ) {
      this.alertService.handleAlert('models.hotel_dto.guest_contact.formErrors.form', 5000, 'bottom', 'end', `snackbar-panel-error-user-config`);
      return;
    }
    this.putGuestContactInfo(this.customer_id, this.guestContactForm.value);
  }

  putGuestContactInfo(customer_id, data){
    this.waiting = true;
    this.hotelService.putGuestContactInfo(customer_id, data).subscribe(data => {
      this.guestContactForm.patchValue(data);
      this.waiting = false;
      this.alertService.handleAlert('models.user.data_saved_correctly', 5000, 'bottom', 'end', `snackbar-panel-success-user-config`);
    });
  }
}
